<template>
  <div class="show-print">
    <table width="100%" class="print-header" v-if="client.addressCollection">
      <tbody>
        <tr>
          <td width="170">
            <img
              class="client-logo"
              :src="client.image != '' ? urlImage + client.image : logoSystem"
              width="155"
            />
          </td>
          <td>
            <h4 class="text-info">
              {{ client.businessName
              }}{{
                client.phoneCollection[0].number
                  ? ' - ' + client.phoneCollection[0].number
                  : ''
              }}
            </h4>
            <span class="subtitle-header">
              CPF/CNPJ: {{ client.identification }} <br />
              <template v-if="client.addressCollection[0]">
                {{ client.addressCollection[0].street }},
                {{ client.addressCollection[0].number }} -
                {{ client.addressCollection[0].neighbourhood }} <br />
                {{ client.addressCollection[0].zipCode.zipCode || cep }} -
                {{ client.addressCollection[0].zipCode.city.name }} -
                {{ client.addressCollection[0].zipCode.city.state.name }}
              </template>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { SYSTEM_VARIABLE } from '@/modules/Application/enums/Environment';

export default {
  name: 'PrintHeader',
  data() {
    return {
      urlImage: process.env.VUE_APP_S3_IMG_URL,
      urlImageDefault: process.env.VUE_APP_BASE_URL,
      LANDINGPAGE_URL: SYSTEM_VARIABLE.LANDINGPAGE_URL,
    };
  },
  computed: {
    ...mapState('client', ['client']),
    logoSystem() {
      const domain = this.LANDINGPAGE_URL;
      if (domain.indexOf('clipp360')) {
        return '../../assets/themes/clipp360/images/logo.png';
      }
      return '../../assets/themes/clippFacil/images/logo.png';
    },
  },
};
</script>
